<template>
  <div class="w-85per dp-inblock">
    <div class="title" style="position: relative">
      <h2>프로그램 등록</h2>
      <p>
        - 미리보기 시 과목 탭 부분 및 전체과정 미리보기만 활성화 되어
        보여집니다. <br />
        - 검색 등 기타 기능은 수강신청 등록 후 수강신청 관리 > 미리보기에서
        확인할 수 있습니다.<br />
        - 프로그램이 2개 이상일 경우 프로그램 선택 페이지가 자동 생성되며,
        학습자에게 Access Code 입력 후 노출됩니다.<br />
        - 각 수강신청 당 프로그램 1개는 필수입니다.<br />
        - 과목이 1개 일 경우 탭이 생성되지 않으며, 2개 이상 시 탭이 생성됩니다.
        <br />
        <span class="txt-red"
          >* 입력박스나 입력했던 값이 안보이는 경우 새로고침하여 진행해 주세요.
          (저장했던 값은 날아가지 않습니다.)</span
        >
        <br />
        <span class="txt-red"
          >* 다른 프로그램을 더 추가하고 싶을 땐, 수강신청 관리 리스트에서
          프로그램 + 추가버튼을 눌러 진행해주세요.</span
        >
      </p>
      <button
        @click="excelDown()"
        class="admin-btn-default"
        style="position: absolute; right: 0; top: 30px"
      >
        과정 엑셀 업로드 양식 다운로드
      </button>
    </div>

    <table class="admin-table-row">
      <thead>
        <tr>
          <th>프로그램명</th>
          <td>
            <input
              type="text"
              v-model="programName"
              @keyup="checkProgramName()"
              class="w-60per"
              maxlength="45"
              placeholder="40자 이내 입력"
            />
          </td>
        </tr>
        <tr>
          <th>프로그램 형식</th>
          <td>
            <label for="cancle">
              <input
                type="radio"
                v-model="programType"
                value="G"
                name="programType"
                id=""
              />
              <span class="txt-13px ml-05 mr-20">Group</span>
            </label>
            <label for="cancle">
              <input
                type="radio"
                v-model="programType"
                value="L"
                name="programType"
                id=""
              />
              <span class="txt-13px ml-05 mr-20">1:1 Language Lab</span>
            </label>
            <label for="cancle">
              <input
                type="radio"
                v-model="programType"
                value="U"
                name="programType"
                id=""
              />
              <span class="txt-13px ml-05 mr-20">Untact</span>
            </label>
            <label for="cancle">
              <input
                type="radio"
                v-model="programType"
                value="S"
                name="programType"
                id=""
              />
              <span class="txt-13px ml-05 mr-20">특강</span>
            </label>
            <label for="cancle">
              <input
                type="radio"
                v-model="programType"
                value="E"
                name="programType"
                id=""
              />
              <span class="txt-13px ml-05">기타</span>
            </label>
          </td>
        </tr>
        <tr>
          <th>검색 노출 여부</th>
          <td>
            <label>
              <input
                type="radio"
                value="Y"
                name="isSearch"
                v-model="isSearch"
              />
              <span class="txt-13px ml-05 mr-20">Y</span>
            </label>
            <label>
              <input
                type="radio"
                value="N"
                name="isSearch"
                v-model="isSearch"
              />
              <span class="txt-13px ml-05 mr-20">N</span>
            </label>
          </td>
        </tr>
        <tr>
          <th>클래스 중복 신청</th>
          <td>
            <label for="cancle">
              <input
                type="radio"
                v-model="subjectDupType"
                value="A"
                name="subjectDupType"
                id=""
              />
              <span class="txt-13px ml-05 mr-20">중복 가능</span>
            </label>
            <label for="cancle">
              <input
                type="radio"
                v-model="subjectDupType"
                value="O"
                name="subjectDupType"
                id=""
              />
              <span class="txt-13px ml-05 mr-20"
                >과정 내 중복 가능 / 타 과정 중복 불가능</span
              >
            </label>
            <label for="cancle">
              <input
                type="radio"
                v-model="subjectDupType"
                value="N"
                name="subjectDupType"
                id=""
              />
              <span class="txt-13px ml-05 mr-20"
                >과정 내 불가/타 과정 중복 가능</span
              >
              <span class="txt-13px ml-05 mr-05" v-if="subjectDupType == 'N'">
                중복가능 개수 설정 :
                <input
                  class="mr-10"
                  type="number"
                  v-model="subjectDupTypeNLimit"
                  style="width: 50px"
                />
                개
              </span>
              <!-- <span class="font-13 ml-05">* 제한없음, 프로그램 선착순 제한 설정시 하위 모든 과목에 적용.</span> -->
            </label>
            <label for="cancle">
              <input
                type="radio"
                v-model="subjectDupType"
                value="X"
                name="subjectDupType"
                id=""
              />
              <span class="txt-13px ml-05 mr-20">중복 불가</span>
            </label>
            <p v-if="subjectDupType == 'N'">
              <span class="txt-red"
                >※ 0개를 입력하는 경우, 중복 가능 개수에 제한이 없습니다.</span
              >
            </p>
          </td>
        </tr>
        <tr>
          <th>과목 등록</th>
          <td>
            <button
              class="admin-btn-default"
              @click="addClass()"
              data-toggle="modal"
              data-target="#class_add"
            >
              탭추가
            </button>
            <div v-for="(item, index) of allData" :key="index">
              <div class="admin-border-bottom mt-10 pb-10">
                <input
                  v-model="item.className"
                  type="text"
                  @keyup="checkClassName(item.className, index)"
                  class="w-200px"
                  maxlength="23"
                  placeholder="과목명 20자 내외"
                />
                <p v-if="onGridArray[index]" class="dp-inblock mt-10 ml-10">
                  <span v-if="item.mappingData.applyType === 'N'"
                    >신청자 제한 없음</span
                  >
                  <span v-else-if="item.mappingData.applyType === 'AF'">
                    클래스 전체 선착순
                    <span class="bold">{{ item.mappingData.faNum }}</span> 명 |
                    <span v-if="item.mappingData.addWaits"
                      >대기자
                      <span class="bold">{{
                        item.mappingData.waitingNum
                      }}</span>
                      명 |
                    </span>
                    <span v-else>대기자 없음 | </span>
                    <span v-if="item.mappingData.restYn === 'Y'"
                      >잔여인원 표시</span
                    >
                    <span v-else>잔여인원 표시 안함</span>
                  </span>
                  <span v-else>
                    과정별 선착순 |
                    <span v-if="item.mappingData.addWaits">대기자 있음 | </span>
                    <span v-else>대기자 없음 | </span>
                    <span v-if="item.mappingData.restYn === 'Y'"
                      >잔여인원 표시</span
                    >
                    <span v-else>잔여인원 표시 안함</span>
                  </span>
                </p>
                <button
                  class="admin-btn-default float-right ml-10"
                  @click="deleteClass(index)"
                >
                  탭삭제
                </button>
                <button
                  class="admin-btn-default float-right ml-10"
                  @click="openModal(index)"
                  data-toggle="modal"
                  data-target="#comment"
                >
                  클래스 항목 관리
                </button>
                <button
                  class="admin-btn-default float-right ml-10"
                  @click="inputFileOpen(index)"
                >
                  Excel Upload
                </button>
                <input
                  type="file"
                  :id="'excel_upload' + index"
                  style="display: none"
                  @change="readExcelUpload($event, index)"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                />
              </div>
              <div class="mt-10" v-if="onGridArray[index]">
                <ag-grid
                  :gridIndex="gridIndex"
                  :idxOfChanges="idxOfChanges"
                  @dragEvent="dragEvent"
                  @dragColumnEvent="dragColumnEvent"
                  :parentColumns="item.columnDefs"
                  :parentRowdatas="item.rowData"
                  @selectRow="selectRow"
                ></ag-grid>
              </div>
              <div
                class="h-50px mt-10"
                :style="[
                  allData.length > 1
                    ? { 'border-bottom': '1px solid #ddd' }
                    : {},
                ]"
                style=""
                v-if="onGridArray[index]"
              >
                <button
                  class="admin-btn-default ml-10 float-right"
                  @click="addRow(index)"
                >
                  추가
                </button>
                <button
                  class="admin-btn-default float-right"
                  @click="delRow(index)"
                >
                  삭제
                </button>
              </div>
            </div>
          </td>
        </tr>
      </thead>
    </table>
    <div class="line"></div>
    <div class="mt-30 w-100per mg-auto">
      <button @click="prev()" class="admin-btn-default">이전</button>
      <button @click="next()" class="admin-btn-default float-right ml-05">
        <span v-if="isFinishPage">완료하기</span>
        <span v-else>다음</span>
      </button>
      <button @click="save()" class="admin-btn-default float-right ml-05">
        저장
      </button>
      <button @click="preview()" class="admin-btn-default float-right">
        미리보기
      </button>
    </div>
    <item-manage-modal
      v-if="isModalOpened"
      :parentApplys="parentApplys"
      :parentCol="parentCol"
      :gridIndex="gridIndex"
      @save="saveModal"
      @close="closeModal"
    ></item-manage-modal>
    <date-modal
      v-if="isDateModalOpened"
      :parentDate="parentDate"
      :rowIndex="rowIndex"
      :gridIndex="gridIndex"
      @close="closeModal"
      @applyDate="applyDate"
    ></date-modal>
    <time-modal
      v-if="isTimeModalOpened"
      :parentTime="parentTime"
      :rowIndex="rowIndex"
      :gridIndex="gridIndex"
      @close="closeModal"
      @applyTime="applyTime"
    ></time-modal>
    <detail-modal
      v-if="isDetailModalOpened"
      :parentSubjectName="parentSubjectName"
      :parentDetail="parentDetail"
      :rowIndex="rowIndex"
      :gridIndex="gridIndex"
      @close="closeModal"
      @applyDetail="applyDetail"
    ></detail-modal>
    <load-modal
      v-if="isLoadModalOpened"
      :parentIdx="parentIdx"
      @applyProgram="applyProgram"
      @close="closeModal"
    ></load-modal>
  </div>
</template>

<script>
import AgGrid from "@/components/utils/agGrid.vue";
import ItemManageModal from "@/components/reg/enroll/itemManageModal.vue";
import DateModal from "@/components/reg/enroll/dateModal.vue";
import TimeModal from "@/components/reg/enroll/timeModal.vue";
import DetailModal from "@/components/reg/enroll/detailModal.vue";
import LoadModal from "@/components/reg/enroll/loadModal.vue";
import { EmptyCheck } from "@/utils/validation.js";
import XLSX from "xlsx";
// import '@/utils/reg.enroll.grid.js'

export default {
  components: {
    ItemManageModal,
    DateModal,
    TimeModal,
    DetailModal,
    LoadModal,
    AgGrid,
    XLSX,
  },
  data: () => ({
    programName: "", // 프로그램 명
    programType: "G", // 프로그램 형식 G(Group), L(1:1 Language Lab), U(Untact), S(특강), E(기타)
    programDupYn: "Y", // 프로그램 중복신청 여부
    isSearch: "Y", //검색 노출 여부
    subjectDupType: "O", // 과정 중복 신청 여부
    subjectDupTypeNLimit: "0",
    subjectDupOption: "E", // 과정 중복 판단 필드

    isModalOpened: false, // 과정항목 관리 팝업 on/off
    isDateModalOpened: false, // 요일 선택 팝업 on/off
    isTimeModalOpened: false, // 시간 선택 팝업 on/off
    isDetailModalOpened: false, // 상세 및 기타 팝업 on/off
    isLoadModalOpened: false, // 프로그램 선택 모달 (불러오기 시)
    gridIndex: "", // 현재 수정하고 있는 그리드 index
    rowIndex: "", // 현재 수정하고 있는 그리드의 행 index
    parentCol: "", // 과정항목 관리 컬럼 페이지-레이어팝업간 공유 데이터
    parentApplys: "", // 과정항목 관리 신청자수 페이지-레이어팝업간 공유 데이터
    parentDate: "", // 요일 페이지-레이어팝업간 공유 데이터
    parentTime: "", // 교육시간 페이지-레이어팝업간 공유 데이터
    parentDetail: "", // 상세 및 기타 페이지-레이어팝업간 공유 데이터
    parentSubjectName: "", // 상세 및 기타 페이지-레이어팝업간 과정명 공유 데이터
    parentIdx: "", // 불러오기시 프로그램 선택 모달에 idx 전달용
    programIdx: "",
    onGridArray: [false],
    isOnGrid0: false,
    allData: [], // 그리드 전체 데이터

    idxOfChanges: [], // 각 그리드를 몇번 변경했는지 (id 중복 방지)

    isSaved: false, // 저장 여부
    isFinishPage: false, // 현재 페이지가 마지막 페이지인지
    isFetching: false, // 현재 api 로딩중인지

    select_row: -1, // 현재 선택한 로우 index

    excelJsonData: [],
  }),

  mounted() {
    if (sessionStorage.getItem("programDupYn")) {
      this.programDupYn = sessionStorage.getItem("programDupYn");
    }

    if (sessionStorage.getItem("fix")) {
      this.parentIdx = sessionStorage.getItem("pageIdx");
      this.isLoadModalOpened = true;
    }

    var pathArray = this.$route.fullPath.split("/");
    var length = pathArray.length;
    var pageType = pathArray[length - 1];
    var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
    var finishPage = pOrder[pOrder.length - 1];

    if (pageType === finishPage) {
      this.isFinishPage = true;
    }

    this.$EventBus.$on("enrollPopup", (datas) => {
      this.gridIndex = datas.gridIndex;
      this.rowIndex = datas.rowIndex;
      if (datas.type === "day") {
        // 그리드 - 요일 버튼 이벤트 버스
        this.parentDate =
          this.allData[this.gridIndex].rowData[this.rowIndex].day;
        this.isDateModalOpened = true;
      } else if (datas.type === "time") {
        // 그리드 - 교육시간 버튼 이벤트 버스
        var subjectStartTime =
          this.allData[this.gridIndex].rowData[this.rowIndex].subjectStartTime;
        var subjectEndTime =
          this.allData[this.gridIndex].rowData[this.rowIndex].subjectEndTime;

        if (subjectStartTime !== "" && subjectEndTime !== "") {
          var clasStartTimeArr = subjectStartTime.split(":");
          var classEndTimeArr = subjectEndTime.split(":");

          this.parentTime = {
            starthh: clasStartTimeArr[0],
            startmm: clasStartTimeArr[1],
            endhh: classEndTimeArr[0],
            endmm: classEndTimeArr[1],
          };
        } else {
          this.parentTime = "";
        }

        this.isTimeModalOpened = true;
      } else {
        // 그리드 - 상세 및 기타 버튼 이벤트 버스
        this.parentSubjectName =
          this.allData[this.gridIndex].rowData[this.rowIndex].subjectName;
        this.parentDetail =
          this.allData[this.gridIndex].rowData[this.rowIndex].etc;
        this.isDetailModalOpened = true;
      }
    });
  },

  methods: {
    //엑셀 양식 다운로드
    excelDown() {
      location.href =
        "https://kr.object.ncloudstorage.com/itmsugang/excel/process_excel_upload.xlsx";
    },

    //input 파일 태그 오픈
    inputFileOpen(index) {
      document.getElementById("excel_upload" + index).click();
    },
    //엑셀 업로드
    readExcelUpload(event, index) {
      const file = event.target.files[0];
      let reader = new FileReader();
      let tmpResult = {};
      reader.onload = (e) => {
        let data = reader.result;
        let workbook = XLSX.read(data, { type: "binary" });
        workbook.SheetNames.forEach((sheetName) => {
          // console.log(workbook.Sheets[sheetName].A1);
          const roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
          tmpResult = roa;
        });
        this.excelJsonData = tmpResult;
        // console.log(this.excelJsonData);
        if (this.excelJsonData.length > 0) {
          this.allData[index].rowData.splice(
            0,
            this.allData[index].rowData.length
          );
          //    console.log("this.allData[index].rowData" + this.allData[index].rowData);
          for (var i = 0; i < this.excelJsonData.length; i++) {
            this.allData[index].rowData.push({
              index: index,
              language: this.excelJsonData[i].language,
              subjectName: this.excelJsonData[i].subjectName,
              level: this.excelJsonData[i].level,
              day: this.excelJsonData[i].day,
              subjectStartTime: this.excelJsonData[i].subjecStartTime
                ? this.excelJsonData[i].subjecStartTime
                : "",
              subjectEndTime: this.excelJsonData[i].subjectEndTime
                ? this.excelJsonData[i].subjectEndTime
                : "",
              classTime: "",
              place: this.excelJsonData[i].place,
              teacher: this.excelJsonData[i].teacher,
              eduPrice: this.excelJsonData[i].eduPrice
                ? String(this.excelJsonData[i].eduPrice).replace(/[^0-9]/g, "")
                : "",
              bookPrice: this.excelJsonData[i].bookPrice
                ? String(this.excelJsonData[i].bookPrice).replace(/[^0-9]/g, "")
                : "",
              etc: this.excelJsonData[i].etc,
              faNum: this.excelJsonData[i].faNum,
              waitingNum: this.excelJsonData[i].waitingNum,
              itemType: "",
            });
          }
        }
      };
      reader.readAsBinaryString(file);
    },

    // 수정시 해당 프로그램 불러오기
    applyProgram(idx) {
      var programIdx = idx;
      this.programIdx = idx;
      var params = {
        programIdx: programIdx,
      };
      this.axios
        .get(
          this.axios.root + this.axios.port + `/program/${programIdx}`,
          params
        )
        .then((res) => {
          this.programName = res.data.program.program_name;
          this.programType = res.data.program.program_type;
          this.programDupYn = res.data.program.program_dup_YN;
          this.subjectDupType = res.data.program.subject_dup_type;
          this.subjectDupTypeNLimit = res.data.program.subject_dup_type_n_limit;
          this.subjectDupOption = res.data.program.subject_dup_option;
          this.isSearch = res.data.program.is_search;
          var allData = [];
          for (var [index, item] of res.data.classList.entries()) {
            var classIdx = item.idx;

            var classData = {
              className: item.class_name,
              classIdx: item.idx,
              rowData: [],
            };
            var mappingData = {};
            var subjectItem = {};
            // 그리드 생성시 Row Drag 가능한 기본 컬럼 입력
            var tempColumnDefs = [
              {
                headerName: "",
                rowDrag: true,
                field: "itemType",
                valueFormatter: () => {
                  return "";
                },
                width: 42.5,
              },
            ];

            var columnOrder; // 컬럼 순서 넣을 변수

            var count = 0; // 과정별 선착순일때 대기자 유무 판별 count

            for (var subject of res.data.subjectList) {
              if (subject.idxItmSugangClass === classIdx) {
                columnOrder = subject.columnOrder;
                mappingData["isReLoad"] = true;
                subject["subjectIdx"] = subject.subjectIdx;
                subject["index"] = index;
                classData.rowData.push(subject);
                mappingData["applyType"] = subject.faType;
                mappingData["restYn"] = subject.restYn;

                if (subject.waitingNum > 0 && subject.faType !== "N") {
                  count += 1;
                  mappingData["addWaits"] = true;
                  mappingData["waitingNum"] = subject.waitingNum;
                  mappingData["faNum"] = subject.faNum;
                } else if (subject.waitingNum === 0 && subject.faType !== "N") {
                  mappingData["addWaits"] = false;
                  mappingData["waitingNum"] = subject.waitingNum;
                  mappingData["faNum"] = subject.faNum;
                }

                subjectItem = subject;
              }
            }

            // 과정별 선착순일때 모든 과정에 대기자가 하나도 없으면 '대기자없음'
            if (mappingData["applyType"] === "SF" && count > 0) {
              mappingData["addWaits"] = true;
            }

            this.gridIndex = index;
            this.idxOfChanges.push({
              index: index,
            });

            var gridData = this.loadItemList(columnOrder);

            for (var item of gridData) {
              if (item.checked) {
                if (item.field === "day") {
                  tempColumnDefs.push({
                    headerName: item.item,
                    field: item.field,
                    cellRenderer: "DateComponent",
                    width: 100,
                  });
                } else if (item.field === "classTime") {
                  tempColumnDefs.push({
                    headerName: item.item,
                    field: item.field,
                    cellRenderer: "TimeComponent",
                    width: 100,
                  });
                } else if (item.field === "etc") {
                  tempColumnDefs.push({
                    headerName: item.item,
                    field: item.field,
                    cellRenderer: "DetailComponent",
                    width: 95,
                  });
                } else {
                  if (item.field === "faNum" || item.field === "waitingNum") {
                    if (mappingData["applyType"] !== "SF") {
                      continue;
                    }
                  } else {
                    tempColumnDefs.push({
                      headerName: item.item,
                      field: item.field,
                      editable: true,
                      // cellRenderer: 'InputComponent',
                      width: 85,
                    });
                  }
                }
              }
            }

            // 팝업에서 선착순 혹은 대기자 선택한 경우 각 필드 추가
            if (mappingData["applyType"] === "SF") {
              tempColumnDefs.push({
                headerName: "선착순",
                field: "faNum",
                editable: true,

                width: 85,
              });
              if (mappingData["addWaits"]) {
                tempColumnDefs.push({
                  headerName: "대기자",
                  field: "waitingNum",
                  editable: true,
                  width: 85,
                });
              }
            }

            classData["gridData"] = gridData;
            classData["mappingData"] = mappingData;
            classData["columnDefs"] = tempColumnDefs;

            allData.push(classData);
            this.allData = JSON.parse(JSON.stringify(allData));

            if (this.onGridArray[0] === false) {
              this.onGridArray[0] = true;
            } else {
              this.onGridArray.push(true);
            }
          }
          this.isLoadModalOpened = false;
        })
        .catch((err) => {
          console.log(err);
          alert(err);
        });
    },

    // 과목명 20자 초과일때 alert
    checkClassName(title, index) {
      if (title.length > 20) {
        this.allData[index].className = title.substring(0, 20);
        alert("과목명은 20자 이내로 입력해주세요.");
        return false;
      }
    },

    // 프로그램명 40자 초과일때 alert
    checkProgramName() {
      if (this.programName.length > 40) {
        this.programName = this.programName.substring(0, 40);
        alert("프로그램명은 40자 이내로 입력해주세요.");
        return false;
      }
    },

    // 각 과정 드래그시 데이터 변경
    dragEvent(rowData, index) {
      this.allData[index].rowData = rowData;
    },

    // 각 컬럼(속성) 드래그시 데이터 변경
    dragColumnEvent(order, index) {
      for (var row of this.allData[index].rowData) {
        row.columnOrder = order;
        // console.log('row.columnOrder', row.columnOrder)
      }
    },

    // 그리드 랜더링 완료된 경우 호출
    onGridReady() {
      this.gridApi = this.gridOptions.api;
      this.gridColumnApi = this.gridOptions.columnApi;
    },

    // 미리보기
    preview() {
      if (!this.isSaved) {
        alert("미리보기를 하려면 먼저 저장을 해야합니다.");
        return false;
      }
      let routeData = this.$router.resolve({
        name: "preview-enroll",
        query: {
          pageIdx: sessionStorage.getItem("programIdx"),
        },
      });
      window.open(routeData.href, "_blank");
    },

    // 이전 페이지 이동
    prev() {
      var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
      var idx = pOrder.indexOf("enroll") - 1;
      this.$router.push(`/admin/reg/${pOrder[idx]}`);
      // this.$router.push('/admin/reg/info')
    },

    // 다음 페이지 이동
    async next() {
      if (this.isSaved) {
        if (this.isFinishPage) {
          alert("수강신청 등록이 완료되었습니다.");
          this.$router.push("/admin/list/main");
        } else {
          var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
          var idx = pOrder.indexOf("enroll") + 1;
          sessionStorage.setItem("step", pOrder[idx]);
          this.$router.push(`/admin/reg/${pOrder[idx]}`);
        }
      } else {
        alert("저장을 먼저 해주세요.");
        return false;
      }
    },

    // 저장 api 호출
    save() {
      // 저장중일때 api 또 전송되는 부분 방지
      if (this.isFetching) {
        alert("저장중입니다...");
        return false;
      }

      // 프로그램명 유효성 검사
      if (!EmptyCheck(this.programName, "프로그램명")) {
        return false;
      }

      var params = {
        idxItmSugangPageMain: sessionStorage.getItem("pageIdx"),
        programName: this.programName,
        programType: this.programType,
        programDupYn: this.programDupYn,
        subjectDupType: this.subjectDupType,
        subjectDupTypeNLimit: this.subjectDupTypeNLimit,
        subjectDupOption: this.subjectDupOption,
        isSearch: this.isSearch,
        classList: [],
      };

      // 저장한 기록이 있는 경우 수정하기위한 programIdx 파라미터 저장
      if (this.programIdx !== "") {
        params["programIdx"] = this.programIdx;
      }

      // api에 전달 전 데이터를 api파라미터 형식에 맞게 맞추기 위해 복사
      var pAllData = JSON.parse(JSON.stringify(this.allData));

      for (let [index, item] of pAllData.entries()) {
        // 과목명 입력 validation 체크
        if (item.className.trim() === "") {
          alert(index + 1 + "번째 과목의 과목명을 입력해주세요.");
          return false;
        }

        // 과정항목 추가로 그리드 생성 여부 체크
        if (!item.rowData) {
          alert(index + 1 + "번째 과목의 과정항목 관리를 선택해주세요.");
          return false;
        }

        // 컬럼 순서 데이터 추가
        var columnOrder = [];
        for (let column of item.columnDefs) {
          if (column.headerName !== "") {
            columnOrder.push(column.headerName);
          }
        }
        columnOrder = columnOrder.join("^");

        // 불필요 key 제거 및 추가, vaildation 체크
        for (let [index, subItem] of item.rowData.entries()) {
          // 교육 시간 validation 체크
          // if (subItem['subjectStartTime'] === '' && subItem['subjectEndTime'] === '') {
          //     alert(item.className + '과목의 ' + (index + 1) + '번째 교육시간을 선택해주세요.')
          //     return false
          // }

          delete subItem["classTime"];
          delete subItem["index"];
          delete subItem["itemType"];
          // if (!subItem['columnOrder']) {
          //     subItem['columnOrder'] = columnOrder
          // }
          subItem["columnOrder"] = columnOrder;

          subItem["faType"] = item.mappingData.applyType;

          if (item.mappingData.applyType === "AF") {
            subItem.faNum = item.mappingData.faNum;
            subItem.restYn = item.mappingData.restYn;

            if (item.mappingData.addWaits) {
              subItem["waitingNum"] = item.mappingData.waitingNum;
            } else {
              subItem["waitingNum"] = 0;
            }
          } else if (item.mappingData.applyType === "SF") {
            subItem["restYn"] = item.mappingData.restYn;
          }

          // 과정별 선착순일때 선착순 및 대기자 입력 유효성검사
          if (subItem["faType"] === "SF") {
            const columnDefsArr = item["columnDefs"];

            const faNumfindIdx = columnDefsArr.findIndex(
              (columnItem) => columnItem.field === "faNum"
            );
            const waitingNumFindIdx = columnDefsArr.findIndex(
              (columnItem) => columnItem.field === "waitingNum"
            );

            //grid column에 faNum이 존재하는지 확인
            // 빈값인 경우에 alert
            if (
              faNumfindIdx > -1 &&
              (subItem["faNum"] === "" || subItem["faNum"] === 0)
            ) {
              alert(
                "선착순의 값을 0이상 입력해주세요.\n테이블에서 안보이는 경우에는 하단 스크롤을 오른쪽으로 드래그 해주세요."
              );
              return false;
            }
            //grid column에 waitingNum이 존재하는지 확인
            if (
              waitingNumFindIdx > -1 &&
              (subItem["waitingNum"] === "" || subItem["waitingNum"] === 0)
            ) {
              alert(
                "대기자의 값을 0이상 입력해주세요.\n테이블에서 안보이는 경우에는 하단 스크롤을 오른쪽으로 드래그 해주세요."
              );
              return false;
            }

            // 그리드에서 숫자를 스트링으로 입력받으므로 타입 변환
            subItem["faNum"] = Number(subItem["faNum"]);
            subItem["waitingNum"] = Number(subItem["waitingNum"]);

            if (subItem["faNum"] === 0 && subItem["waitingNum"] === 0) {
              alert(
                "과정별 선착순인 경우에는 선착순 혹은 대기자를 1이상 입력해주세요.\n테이블에서 안보이는 경우에는 하단 스크롤을 오른쪽으로 드래그 해주세요."
              );
              return false;
            }
          }
        }

        for (var partData of item.rowData) {
          var columnOrder = partData.columnOrder.split("^");

          // eduPrice: 0-9 숫자만 포함된 문자열로 처리
          if (
            partData["eduPrice"] !== null &&
            partData["eduPrice"] !== undefined
          ) {
            partData["eduPrice"] = String(partData["eduPrice"]).replace(
              /[^0-9]/g,
              ""
            );
          }

          // bookPrice: 0-9 숫자만 포함된 문자열로 처리
          if (
            partData["bookPrice"] !== null &&
            partData["bookPrice"] !== undefined
          ) {
            partData["bookPrice"] = String(partData["bookPrice"]).replace(
              /[^0-9]/g,
              ""
            );
          }

          for (var defaultItem of this.returnDefaultItem()) {
            if (columnOrder.includes(defaultItem.item)) {
              continue;
            } else if (defaultItem.field === "faNum") {
              if (item.mappingData.applyType === "AF") {
                continue;
              } else {
                partData[defaultItem.field] = "";
              }
            } else if (defaultItem.field === "waitingNum") {
              if (item.mappingData.applyType === "AF") {
                continue;
              } else {
                partData[defaultItem.field] = "";
              }
            } else {
              partData[defaultItem.field] = "";
            }
          }
        }

        var subjectData = {
          className: item.className,
          classIdx: item.classIdx,
          subjectList: item.rowData,
        };
        params.classList.push(subjectData);
      }

      this.isFetching = true;

      //  프로그램 저장 api
      this.axios
        .post(this.axios.root + this.axios.port + "/program", params)
        .then((res) => {
          this.isFetching = false;
          if (res.data.err_class === 0) {
            // if (!sessionStorage.getItem('fix')) {
            this.programIdx = res.data.programInfo.programIdx;
            for (var [index, saveData] of this.allData.entries()) {
              saveData["classIdx"] =
                res.data.programInfo.classList[index].classIdx;
              for (var [idx, subData] of saveData.rowData.entries()) {
                subData["subjectIdx"] =
                  res.data.programInfo.classList[index].subjectList[
                    idx
                  ].subjectIdx;
              }
            }
            // }
            this.isSaved = true;
            sessionStorage.setItem(
              "programIdx",
              res.data.programInfo.programIdx
            );
            alert("저장되었습니다.");
          }
        })
        .catch((err) => {
          this.isFetching = false;
          alert(err);
        });
    },

    /**
     * @description 오전/점심/저녁 계산
     */
    setSubjectTime(strTime, endTime) {
      let rtnSubjecTime = "오전/점심/저녁";
      const splStrTime = strTime.split(":");
      const splEndTime = endTime.split(":");

      const starttime = Number(splStrTime[0] * 60) + Number(splStrTime[1] * 1);

      const endtime = Number(splEndTime[0] * 60) + Number(splEndTime[1] * 1);

      //한건(오전/점심/저녁) 중에 하나일 경우
      //1.오전
      if (
        starttime >= 0 &&
        starttime <= 660 &&
        endtime >= 0 &&
        endtime <= 660
      ) {
        rtnSubjecTime = "오전";
      }
      //2.점심
      else if (
        starttime >= 661 &&
        starttime <= 780 &&
        endtime >= 661 &&
        endtime <= 780
      ) {
        rtnSubjecTime = "점심";
      }
      //3.저녁
      else if (
        starttime >= 781 &&
        starttime < 1440 &&
        endtime >= 781 &&
        endtime < 1440
      ) {
        rtnSubjecTime = "저녁";
      }
      //4.오전/점심
      else if (
        starttime >= 0 &&
        starttime <= 660 &&
        endtime >= 661 &&
        endtime < 780
      ) {
        rtnSubjecTime = "오전/점심";
      }
      //5.오전 저녁
      else if (
        starttime >= 0 &&
        starttime <= 660 &&
        endtime >= 781 &&
        endtime < 1440
      ) {
        rtnSubjecTime = "오전/저녁";
      }
      //6.점심 저녁
      else if (
        starttime >= 661 &&
        starttime <= 780 &&
        endtime >= 781 &&
        endtime < 1440
      ) {
        rtnSubjecTime = "점심/저녁";
      }

      return rtnSubjecTime;
    },

    // 과정항목 관리 모달 열기
    openModal(index) {
      if (this.allData[index].mappingData) {
        this.parentCol = this.allData[index].gridData;
        this.parentApplys = this.allData[index].mappingData;
      } else {
        this.parentCol = "";
        this.parentApplys = "";
      }
      this.isModalOpened = true;
      this.gridIndex = index;
    },

    // 과정항목 관리 모달 닫기
    closeModal() {
      if (this.isModalOpened) {
        this.isModalOpened = false;
      } else if (this.isDateModalOpened) {
        this.isDateModalOpened = false;
      } else if (this.isTimeModalOpened) {
        this.isTimeModalOpened = false;
      } else if (this.isDetailModalOpened) {
        this.isDetailModalOpened = false;
      } else if (this.isLoadModalOpened) {
        this.isLoadModalOpened = false;
      }
    },

    // 요일 선택 레이어팝업 데이터 전달 받기
    applyDate(day, index, rowIndex) {
      this.allData[index].rowData[rowIndex].day = day;
      this.isDateModalOpened = false;
    },

    // 시간 선택 레이어팝업 데이터 전달 받기
    applyTime(subjectStartTime, subjectEndTime, index, rowIndex) {
      this.allData[index].rowData[rowIndex].subjectStartTime = subjectStartTime;
      this.allData[index].rowData[rowIndex].subjectEndTime = subjectEndTime;
      this.allData[index].rowData[rowIndex].subjectTime = this.setSubjectTime(
        subjectStartTime,
        subjectEndTime
      );
      this.isTimeModalOpened = false;
    },

    // 상세 및 기타 레이어팝업 데이터 전달 받기
    applyDetail(text, index, rowIndex) {
      this.allData[index].rowData[rowIndex].etc = text;
      this.isDetailModalOpened = false;
    },

    // 과정항목 관리 데이터 전달 받기
    async saveModal(gridData, mappingData) {
      this.$nextTick(() => {
        // if (this.allData[mappingData['index']]['classIdx']) {

        // }
        this.allData[mappingData["index"]]["mappingData"] = mappingData;
        this.allData[mappingData["index"]]["gridData"] = gridData;

        // 항목을 처음 생성하는 경우
        if (!mappingData["isReLoad"]) {
          var tempRowData = [];

          // 그리드 생성시 기본 5행 데이터 입력
          for (var i = 0; i < 1; i++) {
            tempRowData.push({
              index: mappingData["index"], // 몇번째 과목인지 확인 index
              language: "",
              subjectName: "",
              level: "",
              day: "",
              subjectStartTime: "",
              subjectEndTime: "",
              classTime: "",
              place: "",
              teacher: "",
              eduPrice: "",
              bookPrice: "",
              etc: "",
              faNum: "",
              waitingNum: 0,
              itemType: "",
            });
          }

          this.allData[mappingData["index"]].rowData = JSON.parse(
            JSON.stringify(tempRowData)
          );
        } else {
          for (var row of this.allData[mappingData["index"]].rowData) {
            if (mappingData.applyType !== "SF") {
              row.faNum = mappingData.faNum;
              row.waitingNum = mappingData.faNum;
              row.faType = mappingData.applyType;
              row.restYn = mappingData.restYn;
            }
          }
          this.idxOfChanges[this.gridIndex].index += 1;
        }

        // 그리드 생성시 Row Drag 가능한 기본 컬럼 입력
        var tempColumnDefs = [
          {
            headerName: "",
            rowDrag: true,
            field: "itemType",
            valueFormatter: () => {
              return "";
            },
            width: 42.5,
          },
        ];

        for (var item of gridData) {
          if (item.checked) {
            if (item.field === "day") {
              tempColumnDefs.push({
                headerName: item.item,
                field: item.field,
                cellRenderer: "DateComponent",
                width: 100,
              });
            } else if (item.field === "classTime") {
              tempColumnDefs.push({
                headerName: item.item,
                field: item.field,
                cellRenderer: "TimeComponent",
                width: 100,
              });
            } else if (item.field === "etc") {
              tempColumnDefs.push({
                headerName: item.item,
                field: item.field,
                cellRenderer: "DetailComponent",
                width: 95,
              });
            } else {
              tempColumnDefs.push({
                headerName: item.item,
                field: item.field,
                editable: true,
                // cellRenderer: 'InputComponent',
                width: 85,
              });
            }
          } else {
            // for (var part of this.allData[mappingData['index']].rowData) {
            //     part[item.field] = '-1'
            // }
          }
        }

        // 팝업에서 선착순 혹은 대기자 선택한 경우 각 필드 추가
        if (mappingData["applyType"] === "SF" && mappingData["addWaits"]) {
          tempColumnDefs.push({
            headerName: "선착순",
            field: "faNum",
            editable: true,
            width: 85,
          });
          tempColumnDefs.push({
            headerName: "대기자",
            field: "waitingNum",
            editable: true,
            width: 85,
          });
        } else if (mappingData["applyType"] === "SF") {
          tempColumnDefs.push({
            headerName: "선착순",
            field: "faNum",
            editable: true,
            width: 85,
          });
        }

        this.allData[mappingData["index"]].columnDefs = JSON.parse(
          JSON.stringify(tempColumnDefs)
        );
        this.onGridArray[mappingData["index"]] = true;

        this.isModalOpened = false;
      });
    },

    // 과목 추가
    addClass() {
      this.onGridArray.push(false);
      this.allData.push({
        className: "",
      });
      this.idxOfChanges.push({
        index: 0,
      });
    },

    // 그리드 행 추가 (마지막 행 추가)
    addRow(index) {
      this.allData[index].rowData.push({
        index: index,
        language: "",
        subjectName: "",
        level: "",
        day: "",
        subjectStartTime: "",
        subjectEndTime: "",
        classTime: "",
        place: "",
        teacher: "",
        eduPrice: "",
        bookPrice: "",
        etc: "",
        faNum: "",
        waitingNum: 0,
        itemType: "",
      });
    },

    // 과목 삭제
    deleteClass(index) {
      if (this.allData[index].classIdx) {
        var con_test = confirm(
          "해당 과목을 삭제하시겠습니까?\n확인을 누르시면 저장된 과목이 삭제됩니다."
        );
        if (con_test == true) {
          var classIdx = this.allData[index].classIdx;

          var params = {
            classIdx: classIdx,
          };

          this.axios
            .delete(
              this.axios.root +
                this.axios.port +
                `/program/delete-class/${classIdx}`,
              params
            )
            .then((res) => {
              if (res.data.err === 0) {
                this.onGridArray[index] = false;
                this.allData.splice(index, 1);
              } else {
                alert(res.data.result);
              }
            });
        } else {
          return false;
        }
      } else {
        this.onGridArray[index] = false;
        this.allData.splice(index, 1);
      }
    },

    // 그리드 행 추가 (마지막 행 삭제)
    delRow(index) {
      if (this.select_row == -1) {
        alert("삭제할 행을 선택해주세요.");
        return false;
      }

      var endIndex = this.allData[index].rowData.length - 1;
      if (endIndex == 0) {
        alert("최소 행이 1개일때는 삭제가 불가능합니다.");
        return false;
      } else {
        // this.allData[index].rowData[endIndex].subjectIdx
        if (this.allData[index].rowData[this.select_row].subjectIdx) {
          // var con_test = confirm("마지막 행의 과정을 삭제하시겠습니까?\n확인을 누르시면 저장된 과정이 삭제됩니다.");
          var con_test = confirm(
            "선택한 행의 과정을 삭제하시겠습니까?\n확인을 누르시면 저장된 과정이 삭제됩니다."
          );
          if (con_test == true) {
            // var subjectIdx = this.allData[index].rowData[endIndex].subjectIdx
            var subjectIdx =
              this.allData[index].rowData[this.select_row].subjectIdx;

            var params = {
              subjectIdx: subjectIdx,
            };
            this.axios
              .delete(
                this.axios.root +
                  this.axios.port +
                  `/program/delete-subject/${subjectIdx}`,
                params
              )
              .then((res) => {
                if (res.data.err === 0) {
                  // this.allData[index].rowData.splice(endIndex, 1)
                  this.allData[index].rowData.splice(this.select_row, 1);
                } else {
                  alert(res.data.result);
                }
              });
          } else {
            return false;
          }
        } else {
          // this.allData[index].rowData.splice(endIndex, 1)
          this.allData[index].rowData.splice(this.select_row, 1);
        }
      }
      // console.log('this.allData[index].rowData[this.select_row]', this.allData[index].rowData[this.select_row])

      // var endIndex = this.allData[index].rowData.length - 1
      // if (endIndex === 0) {
      //     alert('최소 행이 1개일때는 삭제가 불가능합니다.')
      //     return false
      // } else {
      //     console.log('this.allData[index].rowData[endIndex]', this.allData[index].rowData[endIndex])
      //     // this.allData[index].rowData.splice(endIndex, 1);
      //     // alert("aa");
      //     if (this.allData[index].rowData[endIndex].subjectIdx) {
      //         var con_test = confirm("마지막 행의 과정을 삭제하시겠습니까?\n확인을 누르시면 저장된 과정이 삭제됩니다.");
      //         if (con_test == true) {
      //             var subjectIdx = this.allData[index].rowData[endIndex].subjectIdx

      //             var params = {
      //                 subjectIdx: subjectIdx
      //             }

      //             this.axios.delete(this.axios.root + this.axios.port + `/program/delete-subject/${subjectIdx}`, params)
      //                 .then(res => {
      //                     console.log('res', res)
      //                     if (res.data.err === 0) {
      //                         this.allData[index].rowData.splice(endIndex, 1)
      //                     } else {
      //                         alert(res.data.result)
      //                     }
      //                 })
      //         } else {
      //             return false
      //         }
      //     } else {
      //         this.allData[index].rowData.splice(endIndex, 1)
      //     }

      // }
    },
    //그리드 로우 선택
    selectRow(index) {
      this.select_row = index;
    },

    // ag-grid 아이템 리스트 호출 (불러오기 시)
    loadItemList(items) {
      if (items !== "") {
        var returnItem = [];
        var itemList = [
          {
            // 항목 컬럼 데이터
            checked: true,
            item: "언어",
            field: "language",
          },
          {
            checked: true,
            item: "과정명",
            field: "subjectName",
          },
          {
            checked: true,
            item: "레벨",
            field: "level",
          },
          {
            checked: true,
            item: "요일",
            field: "day",
          },
          {
            checked: true,
            item: "교육시간",
            field: "classTime",
          },
          {
            checked: true,
            item: "장소",
            field: "place",
          },
          {
            checked: true,
            item: "강사",
            field: "teacher",
          },
          {
            checked: true,
            item: "교육비",
            field: "eduPrice",
          },
          {
            checked: true,
            item: "교재",
            field: "book",
          },
          {
            checked: true,
            item: "교재비",
            field: "bookPrice",
          },
          {
            checked: true,
            item: "상세 및 기타",
            field: "etc",
          },
          {
            checked: true,
            item: "선착순",
            field: "faNum",
          },
          {
            checked: true,
            item: "대기자",
            field: "waitingNum",
          },
        ];

        for (var orderItem of items.split("^")) {
          for (var columnItem of itemList) {
            if (orderItem === columnItem.item) {
              returnItem.push(columnItem);
            }
          }
        }
        return returnItem;
      } else {
        alert("과정항목을 불러오는데 문제가 생겼습니다.");
        return false;
      }
    },

    // 그리드 항목 컬럼 리스트 가져오기
    returnDefaultItem() {
      var itemList = [
        {
          // 항목 컬럼 데이터
          checked: true,
          item: "언어",
          field: "language",
        },
        {
          checked: true,
          item: "과정명",
          field: "subjectName",
        },
        {
          checked: true,
          item: "레벨",
          field: "level",
        },
        {
          checked: true,
          item: "요일",
          field: "day",
        },
        {
          checked: true,
          item: "교육시간",
          field: "classTime",
        },
        {
          checked: true,
          item: "장소",
          field: "place",
        },
        {
          checked: true,
          item: "강사",
          field: "teacher",
        },
        {
          checked: true,
          item: "교육비",
          field: "eduPrice",
        },
        {
          checked: true,
          item: "교재비",
          field: "bookPrice",
        },
        {
          checked: true,
          item: "상세 및 기타",
          field: "etc",
        },
        {
          checked: true,
          item: "선착순",
          field: "faNum",
        },
        {
          checked: true,
          item: "대기자",
          field: "waitingNum",
        },
      ];

      return itemList;
    },
  },
};
</script>

<style scoped>
div >>> .ag-theme-balham .ag-cell.ag-cell-inline-editing {
  height: 47px;
}

div >>> .ag-theme-balham .ag-cell {
  border-right: 1px solid #d9dcde;
}
</style>
